<script setup lang="ts">
  import { useMMStore } from '@/store/MarvelMachine'
  const mmStore = useMMStore()
  interface IProps {
    class?: string
    type: 'type1' | 'type2' | 'type3'
    removeBoxyOnMobile?: boolean
    removeBoxyOnTablet?: boolean
  }
  const props = defineProps<IProps>()
</script>

<template>
  <div
    class="marvel-machine-boxy"
    :class="`${props.class} marvel-machine-boxy--${props.type} ${
      mmStore.breakpoint.isTablet && props.removeBoxyOnTablet ? 'removeBoxyOnTablet' : ''
    } ${mmStore.breakpoint.isMobile && props.removeBoxyOnMobile ? 'removeBoxyOnMobile' : ''}`"
  >
    <div class="marvel-machine-boxy__inner-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .marvel-machine-boxy {
    border-radius: 35px;
    padding: 13px 13px;
    background: #d2cfda;
    box-shadow: 0 0px 0px 3px #665c7f;
    position: relative;
    display: flex;
    align-items: stretch;
    transition: background 0.5s;
    > .marvel-machine-boxy__inner-wrapper {
      z-index: 2;
    }
  }

  .marvel-machine-boxy--type1 {
    > .marvel-machine-boxy__inner-wrapper {
      background: #fef3d3;
    }
  }

  .marvel-machine-boxy--type2 {
    padding: 5px 8px;
    background: none;
    > .marvel-machine-boxy__inner-wrapper {
      background: rgba(#cfe0e8, 0.85);
      box-shadow: none;
    }
    &:after {
      border-radius: 30px;
      box-shadow: 0 0px 0px 8px #d3cdd9;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: transparent;
      position: absolute;
      width: 98.4%;
      height: 98%;
      content: '';
    }
  }

  .marvel-machine-boxy--type3 {
    padding: 6px;
    > .marvel-machine-boxy__inner-wrapper {
      background: #fefeff;
      box-shadow: inset 3px 0px 0px #e3f1f6;
    }
  }

  .marvel-machine-boxy__inner-wrapper {
    overflow: hidden;
    border-radius: 30px;
    box-shadow: 0 0px 0px 7px white;
    width: 100%;
  }
  @media #{$tabletForMarvel} {
    .marvel-machine-boxy {
      &.removeBoxyOnTablet,
      &.removeBoxyOnMobile {
        padding: 0;
        box-shadow: none;
        > .marvel-machine-boxy__inner-wrapper {
          background: none;
          box-shadow: none;
          padding: 0;
        }
      }
      &:after {
        display: none;
      }
    }
  }
</style>
